// src/data/skills.js

export const skillCategories = {
  frontend: {
    title: "Frontend Development",
    icon: "",
    description: "Creating engaging user interfaces and experiences",
    skills: [
      { name: "React", level: 95, color: "#61DAFB", experience: "3+ years" },
      {
        name: "JavaScript",
        level: 92,
        color: "#F7DF1E",
        experience: "4+ years",
      },
      // {
      //   name: "TypeScript",
      //   level: 88,
      //   color: "#3178C6",
      //   experience: "2+ years",
      // },
      // { name: "Vue.js", level: 82, color: "#4FC08D", experience: "2+ years" },
      { name: "Next.js", level: 90, color: "#000000", experience: "2+ years" },
      {
        name: "Tailwind CSS",
        level: 93,
        color: "#06B6D4",
        experience: "3+ years",
      },
      {
        name: "Sass/SCSS",
        level: 87,
        color: "#CC6699",
        experience: "3+ years",
      },
      { name: "Three.js", level: 78, color: "#000000", experience: "1+ year" },
      { name: "D3.js", level: 75, color: "#F68E56", experience: "1+ year" },
      {
        name: "Framer Motion",
        level: 85,
        color: "#FF0055",
        experience: "2+ years",
      },
    ],
  },

  backend: {
    title: "Backend Development",
    icon: "",
    description: "Building robust and scalable server-side solutions",
    skills: [
      { name: "Python", level: 94, color: "#3776AB", experience: "4+ years" },
      { name: "FastAPI", level: 90, color: "#009688", experience: "2+ years" },
      { name: "Django", level: 87, color: "#092E20", experience: "3+ years" },
      { name: "Node.js", level: 85, color: "#339933", experience: "2+ years" },
      {
        name: "Express.js",
        level: 83,
        color: "#000000",
        experience: "2+ years",
      },
      {
        name: "PostgreSQL",
        level: 88,
        color: "#336791",
        experience: "3+ years",
      },
      { name: "MongoDB", level: 82, color: "#47A248", experience: "1+ years" },
      { name: "Redis", level: 80, color: "#DC382D", experience: "1+ years" },
      { name: "GraphQL", level: 75, color: "#E10098", experience: "2+ year" },
      {
        name: "REST APIs",
        level: 92,
        color: "#25D366",
        experience: "2+ years",
      },
    ],
  },

  design: {
    title: "Design & Multimedia",
    icon: "",
    description: "Creating beautiful and functional design solutions",
    skills: [
      {
        name: "UI/UX Design",
        level: 92,
        color: "#FF6B6B",
        experience: "2+ years",
      },
      { name: "Figma", level: 90, color: "#F24E1E", experience: "3+ years" },
      {
        name: "Adobe Creative Suite",
        level: 87,
        color: "#FF0000",
        experience: "2+ years",
      },
      {
        name: "Photoshop",
        level: 88,
        color: "#31A8FF",
        experience: "3+ years",
      },
      // {
      //   name: "Illustrator",
      //   level: 85,
      //   color: "#FF9A00",
      //   experience: "3+ years",
      // },
      {
        name: "After Effects",
        level: 78,
        color: "#9999FF",
        experience: "1+ years",
      },
      {
        name: "Premiere Pro",
        level: 82,
        color: "#9999FF",
        experience: "2+ years",
      },
      {
        name: "CapCut",
        level: 85,
        color: "#000000",
        experience: "2+ years",
      },
      {
        name: "Prototyping",
        level: 89,
        color: "#4ECDC4",
        experience: "3+ years",
      },
      // {
      //   name: "Design Systems",
      //   level: 86,
      //   color: "#45B7D1",
      //   experience: "2+ years",
      // },
      {
        name: "Motion Graphics",
        level: 82,
        color: "#96CEB4",
        experience: "1 year",
      },
      { name: "Branding", level: 80, color: "#FECA57", experience: "3+ years" },
    ],
  },

  tools: {
    title: "Tools & DevOps",
    icon: "",
    description: "Development tools and deployment technologies",
    skills: [
      {
        name: "Git/GitHub",
        level: 93,
        color: "#F05032",
        experience: "4+ years",
      },
      { name: "VS Code", level: 95, color: "#007ACC", experience: "4+ years" },
      { name: "Claude AI", level: 90, color: "#D97757", experience: "1+ year" },
      { name: "ChatGPT", level: 90, color: "#10A37F", experience: "2+ years" },
      { name: "Docker", level: 82, color: "#2496ED", experience: "2+ years" },
      { name: "AWS", level: 78, color: "#FF9900", experience: "2+ years" },
      { name: "Vercel", level: 88, color: "#000000", experience: "2+ years" },
      { name: "Netlify", level: 85, color: "#00C7B7", experience: "2+ years" },
      { name: "Cloudflare Workers", level: 85, color: "#F38020", experience: "1+ year" },
      { name: "Cloudflare Pages", level: 85, color: "#F38020", experience: "1+ year" },
      { name: "Cloudflare D1", level: 80, color: "#F38020", experience: "1+ year" },
      { name: "Linux", level: 83, color: "#FCC624", experience: "1+ years" },
      // { name: "Nginx", level: 75, color: "#009639", experience: "1+ year" },
      { name: "CI/CD", level: 80, color: "#2088FF", experience: "2+ years" },
      { name: "Webpack", level: 77, color: "#8DD6F9", experience: "2+ years" },
    ],
  },

  mobile: {
    title: "Mobile Development",
    icon: "",
    description: "Building cross-platform mobile applications",
    skills: [
      {
        name: "React Native",
        level: 85,
        color: "#61DAFB",
        experience: "2+ years",
      },
      // { name: "Flutter", level: 78, color: "#02569B", experience: "1+ year" },
      // { name: "Expo", level: 82, color: "#000020", experience: "2+ years" },
      // {
      //   name: "Mobile UI/UX",
      //   level: 88,
      //   color: "#FF6B6B",
      //   experience: "2+ years",
      // },
      // {
      //   name: "App Store Deploy",
      //   level: 75,
      //   color: "#007AFF",
      //   experience: "1+ year",
      // },
      // {
      //   name: "Push Notifications",
      //   level: 80,
      //   color: "#25D366",
      //   experience: "1+ year",
      // },
    ],
  },

  security: {
    title: "Cybersecurity & Pentesting",
    icon: "",
    description: "Security assessment, vulnerability detection, and ethical hacking",
    skills: [
      {
        name: "Penetration Testing",
        level: 78,
        color: "#FF4444",
        experience: "2026 - Present",
      },
      {
        name: "Web App Security (OWASP)",
        level: 80,
        color: "#FF6B35",
        experience: "2026 - Present",
      },
      {
        name: "Vulnerability Assessment",
        level: 78,
        color: "#E53E3E",
        experience: "2026 - Present",
      },
      {
        name: "Burp Suite",
        level: 75,
        color: "#FF6633",
        experience: "2026 - Present",
      },
      {
        name: "Network Security",
        level: 72,
        color: "#C53030",
        experience: "2026 - Present",
      },
      {
        name: "Security Reporting",
        level: 85,
        color: "#10b981",
        experience: "2026 - Present",
      },
      {
        name: "QA Testing",
        level: 58,
        color: "#805AD5",
        experience: "Still Building",
      },
    ],
  },

  ai: {
    title: "AI & Machine Learning",
    icon: "",
    description: "Artificial intelligence and machine learning solutions",
    skills: [
      {
        name: "Machine Learning",
        level: 82,
        color: "#FF6F00",
        experience: "2+ years",
      },
      {
        name: "TensorFlow",
        level: 78,
        color: "#FF6F00",
        experience: "1+ year",
      },
      {
        name: "OpenAI API",
        level: 85,
        color: "#412991",
        experience: "1+ year",
      },
      {
        name: "Natural Language Processing",
        level: 80,
        color: "#4285F4",
        experience: "1+ year",
      },
      {
        name: "Computer Vision",
        level: 75,
        color: "#34A853",
        experience: "1+ year",
      },
      {
        name: "Data Analysis",
        level: 83,
        color: "#E94845",
        experience: "2+ years",
      },
      {
        name: "Python ML Libraries",
        level: 85,
        color: "#3776AB",
        experience: "2+ years",
      },
    ],
  },
};

export const getSkillsByCategory = (category) => {
  return skillCategories[category]?.skills || [];
};

export const getAllSkills = () => {
  return Object.values(skillCategories).flatMap((category) =>
    category.skills.map((skill) => ({ ...skill, category: category.title }))
  );
};

export const getTopSkills = (limit = 10) => {
  return getAllSkills()
    .sort((a, b) => b.level - a.level)
    .slice(0, limit);
};

export const getSkillsStats = () => {
  const allSkills = getAllSkills();
  return {
    totalSkills: allSkills.length,
    categories: Object.keys(skillCategories).length,
    averageLevel: Math.round(
      allSkills.reduce((sum, skill) => sum + skill.level, 0) / allSkills.length
    ),
    expertSkills: allSkills.filter((skill) => skill.level >= 90).length,
    proficientSkills: allSkills.filter(
      (skill) => skill.level >= 80 && skill.level < 90
    ).length,
  };
};

// Soft skills and other competencies
export const softSkills = [
  {
    name: "Problem Solving",
    description: "Analytical thinking and creative solution development",
    level: 95,
    icon: "",
  },
  {
    name: "Communication",
    description: "Clear technical communication and client interaction",
    level: 90,
    icon: "",
  },
  {
    name: "Team Leadership",
    description: "Leading development teams and mentoring junior developers",
    level: 87,
    icon: "",
  },
  {
    name: "Project Management",
    description: "Agile methodologies and project planning",
    level: 85,
    icon: "",
  },
  {
    name: "Adaptability",
    description: "Quick learning of new technologies and frameworks",
    level: 92,
    icon: "",
  },
  {
    name: "Creativity",
    description: "Innovative thinking and creative problem-solving",
    level: 88,
    icon: "",
  },
];

// Languages
export const languages = [
  { name: "English", level: 95, type: "Professional" },
  { name: "Twi", level: 100, type: "Native" },
  { name: "French", level: 70, type: "Conversational" },
  { name: "Spanish", level: 60, type: "Basic" },
];

// Certifications and courses
export const certifications = [
  {
    name: "B.Sc. Computer Science",
    issuer: "All Nations University",
    date: "2025-11-15",
    credentialId: "",
    verificationUrl: "",
  },
  {
    name: "JavaScript (Intermediate) Certification",
    issuer: "HackerRank",
    date: "2024-01-01",
    credentialId: "",
    verificationUrl: "",
  },
  {
    name: "Data Analytics Essentials",
    issuer: "Cisco Networking Academy",
    date: "2024-10-01",
    credentialId: "",
    verificationUrl: "",
  },
  {
    name: "Digital Intelligence Job Simulation",
    issuer: "PwC Switzerland (Forage)",
    date: "2024-11-13",
    credentialId: "",
    verificationUrl: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/4sLyCPgmsy8DA6Dh3/Kaib4AmLSAG5mDsD4_4sLyCPgmsy8DA6Dh3_t245M4nXDd6xiFMve_1731445949513_completion_certificate.pdf",
  },
  {
    name: "Responsive Web Design",
    issuer: "freeCodeCamp",
    date: "",
    credentialId: "fcc270eedbd-aefc-458f-a008-d576814fab92",
    verificationUrl: "https://www.freecodecamp.org/certification/fcc270eedbd-aefc-458f-a008-d576814fab92/responsive-web-design",
  },
  {
    name: "How to Edit Viral Videos",
    issuer: "Udemy",
    date: "2024-10-24",
    credentialId: "UC-1ba8b3c8-d3a9-47c3-9ca7-0b2325dd9b0c",
    verificationUrl: "https://www.udemy.com/certificate/UC-1ba8b3c8-d3a9-47c3-9ca7-0b2325dd9b0c/",
  },
  {
    name: "Social Media Management",
    issuer: "Great Learning",
    date: "",
    credentialId: "PXLQBOUT",
    verificationUrl: "https://www.mygreatlearning.com/certificate/PXLQBOUT",
  },
  {
    name: "AI Fluency: Framework & Foundations",
    issuer: "Anthropic Education",
    date: "2026-09-05",
    credentialId: "",
    verificationUrl: "",
  },
];
